module.exports = __webpack_public_path__ + "static/media/ic_config_graphics.e1bc009c.png";